import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function Locations() {
  const locations = [{
    name: 'Howell Auto Glass Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    note: 'Main showroom and auto glass service center',
    isMain: true
  }, {
    name: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    isMain: false
  }, {
    name: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    isMain: false
  }];
  return <section className="py-16 lg:py-24 bg-slate-50 border-t border-slate-200" data-id="element-514" data-mp="3i4d6wzh7zjhk">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-515" data-mp="2koftnwng9eoy">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-516" data-mp="2knwkb4bv7ymj">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-517" data-mp="2pmr3469u1n6n">
            Auto Glass Service Near Howell, Ann Arbor, Novi & Southeast Michigan
          </h2>
          <p className="text-lg text-slate-600" data-id="element-518" data-mp="3ahwe5rzdq9sp">
            Kosin's Glass serves Howell, Ann Arbor, Novi and communities across
            Southeast Michigan, including Brighton, Fenton, Hartland,
            Fowlerville, Northville, Lansing, East Lansing, Grand Blanc,
            Webberville, Williamston, Livonia, Milford, Pinckney, Whitmore Lake,
            Wixom and nearby communities.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12" data-id="element-519" data-mp="2qtf7xmpz8sgf">
          {locations.map((loc, index) => <div key={index} className={`bg-white rounded-lg p-8 border ${loc.isMain ? 'border-brand-blue shadow-lg shadow-brand-blue/10' : 'border-slate-200 shadow-sm'} relative overflow-hidden scroll-fade-up`} style={{
          animationDelay: `${index * 0.08}s`
        }} data-id="element-520" data-mp="2mtd69dk8rz15" data-mpi={index}>
              {loc.isMain && <div className="absolute top-0 right-0 bg-brand-blue text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-521" data-mp="z5z2ierhllc9">
                  Main Center
                </div>}
              <h3 className="text-xl font-bold text-navy-900 mb-4 pr-16" data-id="element-522" data-mp="q62hcn4b34ly">
                {loc.name}
              </h3>
              <div className="space-y-4" data-id="element-523" data-mp="v5ypmyk1di7b">
                <div className="flex items-start gap-3" data-id="element-524" data-mp="v2t1blj8ekcn">
                  <MapPin className="w-5 h-5 text-slate-400 shrink-0 mt-0.5" data-id="element-525" data-mp="1ivj9djo0kjhn" />
                  <span className="text-slate-600" data-id="element-526" data-mp="1mwlbq9d89bnu">{loc.address}</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-527" data-mp="18wk8in9hps57">
                  <Phone className="w-5 h-5 text-brand-blue shrink-0 mt-0.5" data-id="element-528" data-mp="18w26tb426lpw" />
                  <a href={`tel:${loc.phone.replace(/-/g, '')}`} className="text-navy-900 font-bold hover:text-brand-blue transition-colors" data-id="element-529" data-mp="1du3mrn66u4x5">
                    {loc.phone}
                  </a>
                </div>
                {loc.note && <div className="pt-4 mt-4 border-t border-slate-100" data-id="element-530" data-mp="3r0jt0967lw1u">
                    <p className="text-sm text-slate-500 italic" data-id="element-531" data-mp="3m3tfntlshek4">{loc.note}</p>
                  </div>}
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-lg p-8 border border-slate-200 shadow-sm max-w-2xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12" data-id="element-532" data-mp="3v36oql60414b">
          <div className="flex items-center gap-3" data-id="element-533" data-mp="37brgkbrjmpl5">
            <Clock className="w-8 h-8 text-brand-blue" data-id="element-534" data-mp="33dk43t444afr" />
            <h3 className="text-xl font-bold text-navy-900" data-id="element-535" data-mp="3h3x8jlhsp70c">
              Hours of Operation
            </h3>
          </div>
          <div className="text-slate-600 space-y-1" data-id="element-536" data-mp="3ccyocatorort">
            <p data-id="element-537" data-mp="3cb46x6hmiesh">
              <span className="font-medium text-navy-900" data-id="element-538" data-mp="2onmi9jtnnwtq">Monday–Friday:</span>{' '}
              8:00 a.m. to 5:00 p.m.
            </p>
            <p data-id="element-539" data-mp="2jni2jw0kn64k">
              <span className="font-medium text-navy-900" data-id="element-540" data-mp="2jo05fbhqoilg">Saturday:</span> 9:00
              a.m. to 3:00 p.m.
            </p>
            <p data-id="element-541" data-mp="2x95q8hwzv4y3">
              <span className="font-medium text-navy-900" data-id="element-542" data-mp="32acwudnehy36">Sunday:</span> Closed
            </p>
          </div>
        </div>
      </div>
    </section>;
}